<template>
  <el-dialog
      title="修改公告"
      width="1200px"
      :visible.sync="localNoticeDetailDialogVisible"
      :append-to-body="true"
      @close="closeDialog"
      @open="openDialog"
  >
    <el-form
        label-width="200px"
        :model="noticeDetail"
        :rules="rules"
        ref="noticeForm"
    >

      <el-form-item label="标题：" prop="title">
        <el-tabs v-model="noticeTitleLanguage" type="card">
          <el-tab-pane
              v-for="lang in languages"
              :key="lang.value"
              :label="lang.label"
              :name="lang.value"
          >
            <el-input
                type="textarea"
                :value="noticeDetail.title[lang.value]"
                @change="handleEditorChange('title', lang.value, $event)"
                style="width: 100%"
            ></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>

      <el-form-item label="内容：" prop="content">
        <el-tabs v-model="noticeContentLanguage" type="card">
          <el-tab-pane
              v-for="lang in languages"
              :key="lang.value"
              :label="lang.label"
              :name="lang.value"
          >
            <div v-if="localNoticeDetailDialogVisible">
              <editor
                  :value="noticeDetail.content[lang.value]"
                  @change="handleEditorChange('content', lang.value, $event)"
              ></editor>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave('noticeForm')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import uploadMoulde from "../../../../../components/upload/indexLimit.vue";

export default {
  name: "NoticeDetail",
  props: ["id"],
  data() {
    return {
      // 新增：本地对话框可见状态
      localNoticeDetailDialogVisible: false,
      languages: Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      })),
      noticeTitleLanguage: '',
      noticeContentLanguage: '',
      prospectsActiveLanguage: '',
      rules: {
        code: [{required: true, message: "请输入币种名称"}]
      }
    };
  },
  computed: {
    ...mapState("BannerNewSetting", [
      "noticeDetail"
    ])
  },
  created() {
    this.noticeContentLanguage = this.languages !== undefined && this.languages.length > 0 ? '' + this.languages[0].value + '' : null
    this.noticeTitleLanguage = this.languages !== undefined && this.languages.length > 0 ? '' + this.languages[0].value + '' : null
  },
  watch: {
    // 新增：同步Vuex状态到本地
    '$store.state.BannerNewSetting.noticeDetailDialogVisible': {
      handler(newVal) {
        this.localNoticeDetailDialogVisible = newVal;
      },
      immediate: true
    },
    // 新增：同步本地状态到Vuex
    localNoticeDetailDialogVisible(newVal) {
      this.toggleNoticeDetailDialogVisible(newVal);
    }
  },

  components: {
    Editor, uploadMoulde
  },
  methods: {
    ...mapActions("BannerNewSetting", [
      "updateNotice",
      "detailNotice"
    ]),
    ...mapMutations("BannerNewSetting", [
      "toggleNoticeDetailDialogVisible",
      "setNoticeDetail"
    ]),
    initLanguageFields() {
      return this.languages.reduce((acc, lang) => {
        acc[lang.value] = '';
        return acc;
      }, {});
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 增加防御性类型检查
          const safeStringify = (data) => {
            if (typeof data !== 'object' || data === null) {
              return JSON.stringify(this.initLanguageFields());
            }
            return JSON.stringify(data);
          };

          const payload = {
            ...this.noticeDetail,
            content: safeStringify(this.noticeDetail.content),
            title: safeStringify(this.noticeDetail.title)
          };

          this.updateNotice(payload).then(() => {
            this.$message.success("修改成功！");
            this.closeDialog();
            this.$emit("refresh");
          });
        }
      });
    },
    handleCancel() {
      this.toggleNoticeDetailDialogVisible(false);
    },
    handleChange(key, value) {
      this.setNoticeDetail({
        ...this.noticeDetail,
        [key]: value
      });
    },
    handleEditorChange(type, key, value) {
      this.setNoticeDetail({
        ...this.noticeDetail,
        [type]: {
          ...this.noticeDetail[type],
          [key]: value
        }
      });
    },
    openDialog() {
      this.detailNotice(this.id);
    },
    closeDialog() {
      this.setNoticeDetail({
        id: 0,
        // 修复初始化结构问题，保持对象类型
        title: this.initLanguageFields(),
        content: this.initLanguageFields()
      });
      this.toggleNoticeDetailDialogVisible(false);
      this.$refs["noticeForm"].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
</style>
